(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('loadingTransitionHook', loadingTransitionHook);

    var noop = angular.noop;

    loadingTransitionHook.$inject = ['$window', 'loadingPanel'];
    function loadingTransitionHook($window, loadingPanel) {
        return {
            onBefore: [{}, hook]
        };

        function hook(transition) {
            loadingPanel(true);
            transition.promise
                .catch(noop)
                .finally(loadingPanel.bind(null, false))
        }
    }
})();